import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';
import * as fromGraphql from "./approval-flow-successor.graphql";
import * as fromActions from "./approval-flow-successor.actions"

@Injectable()
export class ApprovalFlowSuccessorEffects {

  removeApprovalFlowStagesSuccessorMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeApprovalFlowStagesSuccessorMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_APPROVAL_SUCCESSOR,
        variables: {
          successorUniqueId: action?.successorUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteApprovalFlowSuccessor({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
